
/* injects from baggage-loader */

'use strict';

export default class ProjectInvestmentWizardStep1Controller {

	constructor($log, InvestmentWizard) {
		'ngInject';

		this.$log = $log;
		this.InvestmentWizard = InvestmentWizard;

		this.amount = '';

		this.agreements = [{
			id: 'infoTaxReporting',
			text: 'Confirm you personal information for tax reporting'
		}, {
			id: 'investorAgreement',
			text: 'Sign the Investor Agreement'
		}, {
			id: 'makePayment',
			text: 'Make your payment'
		}, {
			id: 'confirmAccredited',
			text: 'Confirm your are accredited. We will connect you with our partner <a href="https://www.verifyinvestor.com/" target="_blank">VerifyInvestor</a> to complete this verification.'
		}];

		// Setup agreements
		if (typeof this.InvestmentWizard.investment.agreements === 'undefined') {
			this.InvestmentWizard.investment.agreements = this.agreements;
		}

	}

	$onInit() {

	}


	/**
	 * Called when an agreement box is checked
	 * @param {Object} agreement 
	 */
	agreementChecked(agreement) {

		// Record timestamp of agreement check
		agreement.ts = agreement.checked ? new Date() : undefined;

	}

}



// WEBPACK FOOTER //
// ./src/app/pages/projectInvestmentWizard/step1/projectinvestmentwizard.step1.controller.js